export enum FileFormat {
  Xlsx = 'xlsx',
  Pdf = 'pdf',
}

export enum ExportType {
  PreOrder = 'pre-orders',
  Purchase = 'purchases',
}
